export var CustomGradeCode;
(function (CustomGradeCode) {
    CustomGradeCode["Color"] = "color-1";
    CustomGradeCode["ColorViBox2"] = "color-2";
    CustomGradeCode["Brilliance"] = "bril-1";
    CustomGradeCode["Performance"] = "cutperf-1";
    CustomGradeCode["Fire"] = "fire-1";
    CustomGradeCode["OpticalSymmetry"] = "osym-1";
    CustomGradeCode["BrillianceMarquise"] = "bril-marquise-1";
    CustomGradeCode["FireCushion"] = "fire-cushion-1";
    CustomGradeCode["Fluorescence"] = "fluor-1";
    CustomGradeCode["GirdleBeauty"] = "gb-1";
    CustomGradeCode["DeadZone"] = "dz-1";
})(CustomGradeCode || (CustomGradeCode = {}));
/** @deprecated Use "CustomGradeCode.Color" */
export const CUSTOM_GRADE_COLOR = CustomGradeCode.Color;
/** @deprecated Use "CustomGradeCode.ColorViBox2" */
export const CUSTOM_GRADE_COLOR_VIBOX2 = CustomGradeCode.ColorViBox2;
/** @deprecated Use "CustomGradeCode.Brilliance" */
export const CUSTOM_GRADE_BRILLIANCE = CustomGradeCode.Brilliance;
/** @deprecated Use "CustomGradeCode.Performance" */
export const CUSTOM_GRADE_CUT_PERFORMANCE = CustomGradeCode.Performance;
/** @deprecated Use "CustomGradeCode.Fire" */
export const CUSTOM_GRADE_FIRE = CustomGradeCode.Fire;
/** @deprecated Use "CustomGradeCode.OpticalSymmetry" */
export const CUSTOM_GRADE_OPTICAL_SYMMETRY = CustomGradeCode.OpticalSymmetry;
/** @deprecated Use "CustomGradeCode.BrillianceMarquise" */
export const CUSTOM_GRADE_BRILLIANCE_MARQUISE = CustomGradeCode.BrillianceMarquise;
/** @deprecated Use "CustomGradeCode.FireCushion" */
export const CUSTOM_GRADE_FIRE_CUSHION = CustomGradeCode.FireCushion;
/** @deprecated Use "CustomGradeCode.Fluorescence" */
export const CUSTOM_GRADE_FLUORESCENCE = CustomGradeCode.Fluorescence;
/** @deprecated Use "CustomGradeCode.GirdleBeauty" */
export const CUSTOM_GRADE_GIRDLE_BEAUTY = CustomGradeCode.GirdleBeauty;
